import { Typography, TextField, Link } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { SubmitButton } from "../../components/auth/SubmitButton";
import "../../styles/AuthPages.css";
import { notifErr, notifOk } from "../../components/Functions";
import handleAxiosError from "../../components/ErrorHandler";
import axios from "axios";

const RegisterPage = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    fullName: "",
  });

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/signup`,
        credentials,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        }
      );
      notifOk(response.data);
      setCredentials({ email: "", password: "", fullName: "" });
    } catch (err) {
      notifErr(handleAxiosError(err), null);
      setCredentials({ ...credentials, password: "" });
    }
  };

  return (
    <div className="authContainer">
      <div className="square left"></div>
      <div className="square right"></div>
      <Box>
        <Box
          component="form"
          onSubmit={handleSignup}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "90vh",
            flexDirection: "column",
          }}
        >
          <Typography variant="h5" align="center" fontWeight="bold" mb="0.5rem">
            Registrace
          </Typography>

          <TextField
            id="email"
            placeholder="email"
            variant="outlined"
            required={true}
            value={credentials.email}
            onChange={(e) =>
              setCredentials({ ...credentials, email: e.target.value })
            }
            size="small"
            sx={{ mt: "0.5rem" }}
          />

          <TextField
            id="username"
            placeholder="celé jméno"
            variant="outlined"
            required={true}
            value={credentials.fullName}
            onChange={(e) =>
              setCredentials({ ...credentials, fullName: e.target.value })
            }
            size="small"
            sx={{ mt: "0.5rem" }}
          />

          <TextField
            id="password"
            type="password"
            placeholder="heslo"
            variant="outlined"
            required={true}
            value={credentials.password}
            onChange={(e) =>
              setCredentials({ ...credentials, password: e.target.value })
            }
            size="small"
            sx={{ mt: "0.5rem" }}
          />

          <SubmitButton label={"Zaregistrovat"} />

          <Link
            href="/login"
            variant="body2"
            underline="hover"
            sx={{ mt: "1rem" }}
          >
            Přejít k přihlášení
          </Link>
        </Box>
      </Box>
    </div>
  );
};

export default RegisterPage;
